import { render, staticRenderFns } from "./FieldDateRange.vue?vue&type=template&id=537b98e8&"
import script from "./FieldDateRange.vue?vue&type=script&lang=js&"
export * from "./FieldDateRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports